import { Component, input } from '@angular/core';
import { ChartData } from '../../migrations-card-abstract.directive';

@Component({
  selector: 'ziro-migration-text-row',
  templateUrl: './migrations-text-row.component.html',
  styleUrl: './migrations-text-row.component.scss',
  standalone: false,
})
export class MigrationsTextRowComponent {
  readonly data = input.required<ChartData[]>();
}
